import React from 'react';
import { toast } from 'react-toastify';

const CartModal = ({ cart, getItemDetailsByName, updateCart, onClose, clearCart }) => {

    // const [cart, setCart] = useState({});

    // const clearCart = () => setCart({});

    const total = Object.entries(cart).reduce((sum, [name, qty]) => {
        const item = getItemDetailsByName(name);
        return sum + (item ? item.price * qty : 0);
    }, 0);

    return (
        <div className="modal-overlay">
            <div className="modal-content-container">
                <button className="modal-close-btn" onClick={onClose}>
                    &times;
                </button>
                <h2 className="text-2xl font-bold text-center mb-4">Your Cart</h2>

                {Object.keys(cart).length === 0 ? (
                    <p className="text-center text-gray-600">Your cart is empty.</p>
                ) : (
                    <>
                        <div className="space-y-4 max-h-96 overflow-y-auto pr-2">
                            {Object.entries(cart).map(([name, quantity]) => {
                                const item = getItemDetailsByName(name);
                                return (
                                    <div
                                        key={name}
                                        className="flex justify-between items-center p-3 bg-gray-50 rounded-lg shadow-sm"
                                    >
                                        <div>
                                            <h6 className="text-lg font-semibold text-gray-800">{name}</h6>
                                            <p className="text-sm text-gray-600">₹{item.price} / item</p>
                                        </div>
                                        <div className="flex items-center space-x-2">
                                            <button onClick={() => updateCart(name, quantity - 1)} className="bg-red-500 px-3 py-1 rounded-full text-white">-</button>
                                            <span>{quantity}</span>
                                            <button onClick={() => updateCart(name, quantity + 1)} className="bg-green-500 px-3 py-1 rounded-full text-white">+</button>
                                        </div>
                                        <p className="text-lg font-bold">₹{item.price * quantity}</p>
                                    </div>
                                );
                            })}
                        </div>
                        <div className="flex justify-between items-center mt-6 pt-4 border-t border-gray-200">
                            <p className="text-xl font-bold">Total: ₹{total}</p>
                            {/* <button
                                onClick={() => {
                                    alert('Order placed successfully!');
                                    onClose();
                                }}
                                className="bg-green-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-green-600 transition"
                            >
                                Order Now
                            </button> */}
                            <button
                                onClick={() => {
                                    toast.success('Order placed successfully!');
                                    clearCart();
                                    onClose();
                                }}
                                className="bg-green-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-green-600 transition"
                            >
                                Order Now
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default CartModal;